const state = {
  editInfo: {
    editDialogVisible: false,
    editDialogTitle: '',
    editForm: {},
    key: 0
  }
}

const actions = {}

const mutations = {}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js